import * as THREE from 'three'
import Experience from "../Experience"

const lod = new THREE.LOD();

export default class Flowers {
    constructor() {
        this.experience = new Experience()
        this.scene = this.experience.scene
        this.resources = this.experience.resources
        this.time = this.experience.time
        this.debug = this.experience.debug

        // this.instancedMesh = null

        // Debug
        // if (this.debug.active) {
        //     this.debugFolder = this.debug.ui.addFolder('fish')
        // }

        // Setup
        // this.resource = this.resources.items.flowersModel
        this.resource = this.resources.items.flowersModelSimple
        this.gltfLoader = this.experience.gltfLoader;
        this.isLoadingResource = false;
        // this.count = 1000; // Number of flowers
        this.lodDistance = 5; // LOD distance threshold

        this.setModel()
        // this.setTextures()
        // this.setAnimation()
        // this.setMaterial()

    }

    // Check if hotspot is clicked
    addEventListeners() {
        // window.addEventListener('click', (event) => document.querySelectorAll('.point-fish')[0].switchAnimation(), false);
        // document.querySelectorAll('.point-fish')[0].addEventListener('click', this.switchAnimation)
        // document.querySelectorAll('.point-fish')[0].parentElement.querySelector('.close').addEventListener('click', this.switchAnimation)
    }

    setModel() {
        this.model = this.resource.scene;
        this.originalMesh = this.model.children[0]; // For the textured flowers

        // this.originalMesh = this.model.children[0].children[0]; // Assuming this is a Mesh

        this.geometry = this.originalMesh.geometry.clone(); // Clone it
        this.material = this.originalMesh.material.clone(); // Clone it
        // this.material = new THREE.MeshBasicMaterial(); // Perf test basic material
        this.material.side = THREE.DoubleSide; // Perf test basic material

        const flowerPositions = [];

        // Fill both meshes with the same instance transforms
        const dummy = new THREE.Object3D();
        const flowerCount = flowerPositions.length;

        this.instancedMesh = new THREE.InstancedMesh(
            this.geometry,
            this.material,
            flowerCount
        );

        // this.matrices = [];

        // Using Math.random() is in fact too random, switching between low and high poly models too costly with 10k instances.
        // function mulberry32(seed) {
        //     return function () {
        //         let t = seed += 0x6D2B79F5;
        //         t = Math.imul(t ^ (t >>> 15), t | 1);
        //         t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
        //         return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
        //     };
        // }

        // const rand = mulberry32(12345);

        experience.resources.items.mapModel.scene.traverse((child) => {
            if (child.name.includes('Flowers.')) {
                flowerPositions.push(child.position.clone());
            }
        })

        for (let i = 0; i < flowerCount; i++) {
            const pos = flowerPositions[i];
            dummy.position.copy(pos)

            dummy.rotation.y = Math.random() * Math.PI * 2;

            dummy.scale.set(0.03, 0.03, 0.03);

            dummy.updateMatrix();

            this.instancedMesh.setMatrixAt(i, dummy.matrix);
            this.matrices.push(dummy.matrix.clone()); // For use in LodManager.
        }

        this.instancedMesh.instanceMatrix.needsUpdate = true;

        // Add both to scene
        this.scene.add(this.instancedMesh);
        this.instancedMesh.visible = false;
        this.originalMesh.visible = true;
    }

    setMaterial() {
        let m = this.originalMesh.material

        if (m) {
            m.dispose()
        }

        // m.visible = false
        m = new THREE.MeshBasicMaterial({
            color: 0xffffff,
            envMap: null,
            map: null,
        })
        m.needsUpdate = true;
    }

    setAnimation() {
        this.animation = {}
        this.animation.mixer = new THREE.AnimationMixer(this.model)

        this.animation.actions = {}

        this.animation.actions.path = this.animation.mixer.clipAction(this.resource.animations[0])

        console.log(this.animation.actions.path)

        this.animation.actions.current = this.animation.actions.path
        this.animation.actions.current.play()
        // this.animation.actions.current.time = 50
    }

    update() {
        // const cameraWorldPos = new THREE.Vector3();
        // cameraControls.getPosition(cameraWorldPos);

        // const cameraDistance = cameraWorldPos.length();

        // if (cameraDistance < this.lodDistance) {
        //     // Close enough for high-detail
        //     if (!this.isHighDetailLoaded && !this.isLoadingHighDetail) {
        //         this.loadHighDetail();
        //     }

        //     if (this.isHighDetailLoaded) {
        //         this.highInstancedMesh.visible = true;
        //         this.lowInstancedMesh.visible = false;
        //     }
        // } else {
        //     // Far away — always show low-detail
        //     if (this.lowInstancedMesh) {
        //         this.lowInstancedMesh.visible = true;
        //     }
        //     if (this.highInstancedMesh) {
        //         this.highInstancedMesh.visible = false;
        //     }
        // }
        // this.animation.mixer.update(this.time.delta / 1000) // Divide by 1000 because it's in milliseconds
    }
}